module.exports = __webpack_public_path__ + "img/maneken_pos_7_back.6d283e33.png";